module.exports = __webpack_public_path__ + "static/media/snap-example.a2a24090.png";